import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import {
  // Card,
  // CardText,
  // CardBody,
  // CardLink,
  Col,
  // Row,
  // Media,
  Badge
} from 'reactstrap';
import YoutubeImg from './img/youtube (1).svg';
import PlayVideo from './img/play-button (1).svg';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import {
  Grid,
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Collapse,
  Avatar,
  IconButton,
  Typography,
  Chip,
  CardActionArea,
  Snackbar
} from '@material-ui/core';
import {
  AvatarGroup
} from '@material-ui/lab/AvatarGroup';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 345,
    margin: '10px',
    cursor: 'pointer',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: 'black',
    width: theme.spacing(7),
    height: theme.spacing(7),
    padding: '5px'
  },
  content: {
    height: '100px'
  },
  companyIcon: {
    padding: '5px'
  }
}));

const CardApp = ({
  colnum,
  imgsrc,
  title,
  subtitle,
  description,
  link,
  tags,
  href,
  status,
  logoCompany,
  company,
  video,
  openModal
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const { vertical, horizontal, open } = state;

  const handleClick = newState => () => {
    setState({ open: true, ...newState });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  return (
    <Col
      lg={colnum}
      className={classes.root}
    >
      <Card elevation={6}>
        <CardActionArea
          onClick={() => {
            if (status !== 'Coming Soon') {
              // if (link === '') {
              window.open(href, '_blank');
              // } else {
              //   history.push(link);
              // }
            }
          }}

        >
          <CardHeader
            avatar={
              <Avatar
                aria-label="recipe"
                className={classes.avatar}
                src={imgsrc}
                alt={title}
                title={title}
              />
            }
            action={
              <div>
                <Avatar
                  className={classes.companyIcon}
                  src={logoCompany}
                  alt={company}
                  title={company}
                />
                {/* <Avatar>
                  <IconButton aria-label="settings">
                    <MoreVertIcon />
                  </IconButton>
                </Avatar> */}
              </div>
            }
            title={<FormattedMessage
              id={title}
            />}
            subheader={
              <div>
                <Grid
                  item
                  justify="flex-start"
                  xs={6}
                >
                  <FormattedMessage
                    id={subtitle}
                  />
                </Grid>
                <Grid
                  item
                  justify="flex-end"
                  xs={6}
                >
                  {status === 'Coming Soon' &&
                    <div className="label">
                      <Badge color="primary" pill>{status}</Badge>
                    </div>
                  }
                  {status === 'Beta' &&
                    <div className="label">
                      <Badge color="warning" pill>{status}</Badge>
                    </div>
                  }
                  {status === 'New' &&
                    <div className="label">
                      <Badge color="success" pill>{status}</Badge>
                    </div>
                  }
                </Grid>
                <Grid item xs={12}>
                  {(tags) && tags.map((tag, index) => (
                    <Badge color="light" pill key={index}>
                      <a href="#">{tag}</a>
                    </Badge>
                  ))}
                </Grid>
              </div>
            }
            onClick={() => {
              if (link === '') {
                window.open(href, '_blank');
              } else {
                history.push(link);
              }
            }}
          />
          <CardContent
            className={classes.content}
            onClick={() => {
              if (status !== 'Coming Soon') {
                // if (link === '') {
                window.open(href, '_blank');
                // } else {
                //   history.push(link);
                // }
              }
            }}
          >
            <Typography variant="body2" color="textSecondary" component="p">
              <FormattedMessage
                id={description}
              />
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions disableSpacing>
          {/* <IconButton aria-label="add to favorites">
            <FavoriteIcon />
          </IconButton> */}
          <IconButton
            className={clsx(classes.expand, {
              [classes.expandOpen]: expanded,
            })}
          // onClick={handleExpandClick}
          // aria-expanded={expanded}
          // aria-label="show more"
          >
            {/* <ExpandMoreIcon /> */}
            <Typography variant="body2" color="textSecondary" component="p">
              {`powered by ${company}`}
            </Typography>
          </IconButton>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              Hello Guigui
            </Typography>
          </CardContent>
        </Collapse>
      </Card>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        key={`${vertical},${horizontal}`}
        open={open}
        onClose={handleClose}
        message="Copy to clipboard"
        autoHideDuration={3000}
      />
    </Col>
  );
}


CardApp.propTypes = {
  colnum: PropTypes.number.isRequired,
  imgsrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default CardApp;
